import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { handleAuth } from "../../../components/Login/Auth";
import AxiosInstance from "../../AxiosInstance";
import InvoiceDetail from "./Views/InvoiceDetail";

import sendToast from "../../../components/Toast/sendToast";
import showToast from "../../../components/Toast/Toster";
import sendSwal from "../../../components/Swal/sendSwal";
import CustomSwal from "../../../components/Swal/CustomSwal";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PrintIcon from "@mui/icons-material/Print";
import { useUserType } from "../../../contexts/UserTypeContext";
import { useWebSocket, useDocumentStatusListener } from "../../../hooks/useWebSocket";
import { getItem } from "../../../utils/storage";
import EmailDisabledModal from "../../../components/EmailDisabledModal/EmailDisabledModal";
import { Box } from "@mui/material";

/** Invoice details ⋮ menu — Jobber-style pastel icon tiles; handlers unchanged */
const invoiceDetailMenuIconTile = (bg, border) => ({
  width: 32,
  height: 32,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  backgroundColor: bg,
  border: `1px solid ${border}`,
});
const IDET_ICON_COLOR = "#0f2b46";
const IDET_TILE_PDF_BG = "#FEF2F2";
const IDET_TILE_PDF_BORDER = "rgba(220, 38, 38, 0.15)";
const IDET_TILE_PRINT_BG = "#EFF6FF";
const IDET_TILE_PRINT_BORDER = "rgba(37, 99, 235, 0.18)";

const options = { year: "numeric", month: "short", day: "numeric" };

function InvoiceDetails() {
  const baseUrl = import.meta.env.VITE_BASE_API;

  useEffect(() => {
    handleAuth(navigate, location);
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  const { CompanyUrl } = useParams();
  const [invoicedata, setInvoicedata] = useState({});
  const [data, setdata] = useState({});
  const [loader, setLoader] = useState(true);
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState("");
  const [mail, setMail] = useState(false);
  const [selectedFileUri, setSelectedFileUri] = useState(null);
  const [emailDisabledModalOpen, setEmailDisabledModalOpen] = useState(false);
  const [emailDisabledMessage, setEmailDisabledMessage] = useState("");
  const [openSignPDF, setOpenSignPDF] = useState(false);
  const [collectSignatureLoader, setCollectSignatureLoader] = useState(false);
  const [progress, setProgress] = useState(0);
  const [collectSignatureSwalOpen, setCollectSignatureSwalOpen] = useState(false);
  const [cancelInvoiceSwalOpen, setCancelInvoiceSwalOpen] = useState(false);

  const simulateProgress = () => {
    let simulatedProgress = 0;
    const interval = setInterval(() => {
      simulatedProgress += 5;
      setProgress(simulatedProgress);

      if (simulatedProgress >= 100) {
        clearInterval(interval);
      }
    }, 200);
  };

  const [tokenDecode, setTokenDecode] = useState({});
  const [DateDecode, setDateDecode] = useState("MM/DD/YYYY");
  const fetchDatas = async () => {
    try {
      const res = await handleAuth(navigate, location);
      setTokenDecode(res?.data);
      setDateDecode(res?.themes);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchDatas();
  }, []);

  const [dateFormat, setDateFormat] = useState("MM/DD/YYYY");
  useEffect(() => {
    const handleDateFormat = () => {
      if (DateDecode?.Format) {
        setDateFormat(DateDecode?.Format);
      } else {
        setDateFormat("MM/DD/YYYY");
      }
    };

    handleDateFormat();
  }, [DateDecode]);

  let fetchData = async () => {
    try {
      const res = await AxiosInstance.get(
        `/v1/invoice/invoice_detail/${location?.state?.id}`
      );
      let invoiceData = res?.data?.data;
      // Enrich CalculatedTaxes with feeType and feeAmount from tax records
      if (invoiceData?.CalculatedTaxes && invoiceData.CalculatedTaxes.length > 0) {
        try {
          const CompanyId = getItem("CompanyId");
          const taxesRes = await AxiosInstance.get(
            `/v1/tax/get-all-taxes/${CompanyId}`
          );
          // Filter out deleted taxes
          const allTaxes = (taxesRes?.data?.data || []).filter(tax => !tax.isDeleted);
         
          // Enrich CalculatedTaxes with feeType and feeAmount
          invoiceData.CalculatedTaxes = invoiceData.CalculatedTaxes.map((calculatedTax) => {
            // If already has feeType and feeAmount, use them
            if (calculatedTax.feeType && calculatedTax.feeAmount !== undefined) {
             
              return calculatedTax;
            }
            // Find matching tax record by name and type
            const matchingTax = allTaxes.find((tax) => {
              const taxTypes = Array.isArray(tax.types) ? tax.types : (tax.type ? [tax.type] : []);
              const calculatedTaxType = calculatedTax.type || calculatedTax.types?.[0];
              const nameMatch = tax.name?.trim() === calculatedTax.name?.trim();
              const typeMatch = taxTypes.some(t => {
                const taxType = t?.toLowerCase();
                const calcType = calculatedTaxType?.toLowerCase();
                return taxType === calcType ||
                       (taxType === "material" && calcType === "materials") ||
                       (taxType === "materials" && calcType === "material");
              });
              return nameMatch && typeMatch;
            });
            if (matchingTax) {
             
              // Determine feeType from matching tax
              const feeType = matchingTax.feeType ||
                             (matchingTax.feeAmount !== null && matchingTax.feeAmount !== undefined ? "Fixed" : "Percentage");
              // Get the correct value based on feeType
              const feeAmount = feeType === "Fixed"
                ? (matchingTax.feeAmount || calculatedTax.amount)
                : null;
              const percentage = feeType === "Percentage"
                ? (matchingTax.percentage || calculatedTax.percentage || 0)
                : (matchingTax.percentage || 0);
              return {
                ...calculatedTax,
                feeType: feeType,
                feeAmount: feeAmount,
                percentage: percentage,
              };
            }
            // If no matching tax found, infer from CalculatedTaxes data
            const inferredFeeType =
              (calculatedTax.percentage === null || calculatedTax.percentage === 0 || calculatedTax.percentage === undefined) &&
              calculatedTax.amount > 0
                ? "Fixed"
                : "Percentage";
            const inferredFeeAmount = inferredFeeType === "Fixed" ? calculatedTax.amount : null;
           
            return {
              ...calculatedTax,
              feeType: inferredFeeType,
              feeAmount: inferredFeeAmount,
            };
          });
         
        } catch (taxError) {
         
          // If tax fetch fails, still try to infer feeType from CalculatedTaxes data
          invoiceData.CalculatedTaxes = invoiceData.CalculatedTaxes.map((calculatedTax) => {
            // If already has feeType, use it
            if (calculatedTax.feeType) {
              return calculatedTax;
            }
            const inferredFeeType =
              (calculatedTax.percentage === null || calculatedTax.percentage === 0 || calculatedTax.percentage === undefined) &&
              calculatedTax.amount > 0
                ? "Fixed"
                : "Percentage";
            const inferredFeeAmount = inferredFeeType === "Fixed" ? calculatedTax.amount : null;
           
            return {
              ...calculatedTax,
              feeType: inferredFeeType,
              feeAmount: inferredFeeAmount,
            };
          });
        }
      }
      setInvoicedata(invoiceData);






    } catch (error) {
      console.error("Error: ", error?.messae);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // WebSocket connection for real-time document status updates
  // Use invoicedata?.CompanyId as primary source (works for all roles including workers)
  // Fallback to tokenDecode?.CompanyId, then sessionStorage as last resort
  const CompanyId = invoicedata?.CompanyId || tokenDecode?.CompanyId || getItem("CompanyId");
  const documentIds = invoicedata?.dropboxFiles?.map(
    (file) => file?.signatureRequestId
  ).filter(Boolean) || [];

  // Only initialize WebSocket when we have a valid CompanyId to prevent infinite reconnection
  const { socket, isConnected, error: wsError } = useWebSocket(
    CompanyId ? {
      companyId: CompanyId,
      documentIds: documentIds,
      invoiceId: invoicedata?.InvoiceId,
    } : undefined
  );

  // Listen for document status updates via WebSocket
  useDocumentStatusListener(socket, null, fetchData);
  const handleCopy = () => {
    const fullName = `${invoicedata?.customer?.FirstName?.charAt(
      0
    )?.toUpperCase()}${invoicedata?.customer?.FirstName?.slice(
      1
    )} ${invoicedata?.customer?.LastName?.charAt(
      0
    )?.toUpperCase()}${invoicedata?.customer?.LastName?.slice(1)}`;
    navigator.clipboard.writeText(fullName);
  };

  const handleEditClick = (id) => {
    if (tokenDecode?.Role === "Worker") {
      navigate(`/${CompanyUrl}/staff-member/addinvoice`, {
        state: {
          invoiceId: location?.state?.id,
          navigats: [...(location?.state?.navigats || []), "/addinvoice"],
        },
      });
    } else if (CompanyUrl) {
      navigate(`/${CompanyUrl}/addinvoice`, {
        state: {
          invoiceId: location?.state?.id,
          navigats: [...(location?.state?.navigats || []), "/addinvoice"],
        },
      });
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const sendMail = async () => {
    try {
      setLoader(true);
      const mailRes = await AxiosInstance.post(
        `/v1/invoice-payment/send_mail_full_payment/${location?.state?.id}`
      );
      if (mailRes?.data?.statusCode === 200) {
        if (mailRes?.data?.emailNotSent) {
          showToast.warning(mailRes?.data?.message || "No email was sent.");
        } else {
          showToast.success(mailRes?.data?.message);
        }
      } else if (mailRes?.data?.statusCode === 209) {
        if ((mailRes?.data?.reason === "email_disabled" || mailRes?.data?.reason === "not_configured") && tokenDecode?.Role === "Company") {
          setEmailDisabledMessage(mailRes?.data?.message || "Email is not configured or disabled for this company.");
          setEmailDisabledModalOpen(true);
        } else {
          showToast.warning(mailRes?.data?.message || "You have reached the email limit");
        }
      } else {
        sendToast(mailRes?.data?.message);
      }
    } catch (error) {
      if (error?.response?.status === 209 || error?.response?.data?.statusCode === 209) {
        if ((error?.response?.data?.reason === "email_disabled" || error?.response?.data?.reason === "not_configured") && tokenDecode?.Role === "Company") {
          setEmailDisabledMessage(error?.response?.data?.message || "Email is not configured or disabled for this company.");
          setEmailDisabledModalOpen(true);
        } else {
          showToast.warning(error?.response?.data?.message || "You have reached the email limit");
        }
      } else {
        sendToast("Error While Sending Mail");
      }
    } finally {
      setLoader(false);
    }
  };

  // Helper function to sanitize filename by removing/replacing invalid characters
  const sanitizeFileName = (str) => {
    if (!str) return "";
    return str
      .replace(/[<>:"/\\|?*]/g, "") // Remove invalid filename characters
      .replace(/\s+/g, "_") // Replace spaces with underscores
      .trim();
  };

  // Helper function to generate a readable PDF filename
  const generatePDFFileName = () => {
    const customerFirstName = invoicedata?.customer?.FirstName || "";
    const customerLastName = invoicedata?.customer?.LastName || "";
    const customerName = `${customerFirstName} ${customerLastName}`.trim();
    const invoiceNumber = invoicedata?.InvoiceNumber || "";
    const invoiceTitle = invoicedata?.Subject || invoicedata?.account_name || "";

    // Build filename parts
    const parts = ["Invoice"];
    
    if (customerName) {
      parts.push(sanitizeFileName(customerName));
    }
    
    if (invoiceNumber) {
      parts.push(`#${invoiceNumber}`);
    }
    
    if (invoiceTitle && invoiceTitle !== customerName) {
      parts.push(sanitizeFileName(invoiceTitle));
    }

    // Fallback to ID if no other info available
    if (parts.length === 1) {
      parts.push(location?.state?.id || "document");
    }

    return `${parts.join("_")}.pdf`;
  };

  const downloadPdf = async () => {
    try {
      const res = await AxiosInstance.post(
        `/v1/invoice/invoicepdf/${location?.state?.id}`,
        {}
      );
      if (res?.data?.statusCode === 200) {
        const url = `${baseUrl}/v1/cdn/upload/${res?.data?.fileName}`;

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.blob();
          })
          .then((blob) => {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = generatePDFFileName();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          })
          .catch((error) =>
            console.error(
              "There was a problem with the fetch operation:",
              error
            )
          );
      }
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const generatePDF = async () => {
    try {
      const res = await AxiosInstance.post(
        `/v1/invoice/invoicepdf/${location?.state?.id}`,
        {}
      );
      if (res.data.statusCode === 200) {
        const url = `${baseUrl}/v1/cdn/upload/${res?.data?.fileName}`;

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.blob();
          })
          .then((blob) => {
            const pdfUrl = window.URL.createObjectURL(blob);

            const newTab = window.open(pdfUrl, "_blank");
            if (newTab) {
              newTab.focus();
            } else {
              showToast.warning("Please allow popups for this site.");
            }
          })
          .catch((error) => {
            console.error(
              "There was a problem with the fetch operation:",
              error
            );
          });
      }
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };
  const [invoiceStatus, setInvoiceStatus] = useState(
    invoicedata?.Status || "Unpaid"
  );
  useEffect(() => {
    if (invoicedata?.Status) {
      setInvoiceStatus(invoicedata.Status);
    }
  }, [invoicedata]);
  const handleCancelInvoice = () => {
    setCancelInvoiceSwalOpen(true);
  };

  const handleCancelInvoiceConfirm = async (reason) => {
    try {
      const response = await AxiosInstance.put(
        `/v1/invoice/cancel/${location?.state?.id}`,
        {
          data: { DeleteReason: reason },
        }
      );
      // Backend persists cancelled invoices as "Void" — keep detail UI in sync
      // with the list view so the status label stays consistent.
      setInvoiceStatus(response?.data?.data?.Status || "Void");
        showToast.success("Invoice cancelled successfully!", {
        position: "top-center",
        autoClose: 1000,
      });
    } catch (error) {
      console.error("Error cancelling invoice:", error);
      if(error?.response?.data?.statusCode === 400){
        showToast.error(error?.response?.data?.message);
      }else{
      showToast.error("Failed to cancel invoice!", {
          position: "top-center",
          autoClose: 1000,
        });
      }
    }
    setCancelInvoiceSwalOpen(false);
  };

  const handleCancelInvoiceClose = () => {
    setCancelInvoiceSwalOpen(false);
  };

  const handleOpenSignPDFDialog = async (fileUri) => {
    try {
      // If it's a signature request endpoint, we need to fetch with auth token
      if (fileUri && fileUri.includes('/signature_request/files_as_data_uri/')) {
        // Extract the endpoint path (remove base URL if present)
        let endpointPath = fileUri;
        const baseUrl = import.meta.env.VITE_BASE_API || '';
        if (baseUrl && fileUri.startsWith(baseUrl)) {
          endpointPath = fileUri.replace(baseUrl, '');
        } else if (fileUri.startsWith('http://') || fileUri.startsWith('https://')) {
          // Extract just the path part
          const urlObj = new URL(fileUri);
          endpointPath = urlObj.pathname;
        }
        
        const response = await AxiosInstance.get(endpointPath, {
          responseType: 'blob',
          validateStatus: function (status) {
            // Don't throw error for 400/500 so we can handle the error message
            return status < 500;
          }
        });
        
        // Check if response is an error (400/500) - might be JSON error instead of blob
        if (response.status >= 400) {
          // Try to parse error message from response
          let errorMessage = "Failed to load PDF. Please try again.";
          try {
            const text = await response.data.text();
            const errorData = JSON.parse(text);
            if (errorData && errorData.message) {
              errorMessage = errorData.message;
            }
          } catch (parseError) {
            // If can't parse, use default message
            console.error("Error parsing error response:", parseError);
          }
          showToast.error(errorMessage);
          return;
        }
        
        // Check if response data is actually a PDF (starts with PDF header)
        const blobData = response.data;
        if (blobData instanceof Blob && blobData.type === 'application/json') {
          // It's JSON error, not PDF
          const text = await blobData.text();
          const errorData = JSON.parse(text);
          const errorMessage = errorData?.message || "Failed to load PDF. Please try again.";
          showToast.error(errorMessage);
          return;
        }
        
        // Create blob URL from the response
        const blob = new Blob([blobData], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        setSelectedFileUri(blobUrl);
      } else {
        // For other URLs, use directly
        setSelectedFileUri(fileUri);
      }
      setOpenSignPDF(true);
    } catch (error) {
      console.error("Error loading PDF:", error);
      // Check if error response has a message
      let errorMessage = "Failed to load PDF. Please try again.";
      if (error.response && error.response.data) {
        try {
          // If it's a blob, try to parse it as JSON
          if (error.response.data instanceof Blob) {
            const text = await error.response.data.text();
            const errorData = JSON.parse(text);
            if (errorData && errorData.message) {
              errorMessage = errorData.message;
            }
          } else if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        } catch (parseError) {
          // Use default message if parsing fails
          console.error("Error parsing error response:", parseError);
        }
      }
      showToast.error(errorMessage);
    }
  };

  const handleCloseDialog = () => {
    // Clean up blob URL if it exists
    if (selectedFileUri && selectedFileUri.startsWith('blob:')) {
      window.URL.revokeObjectURL(selectedFileUri);
    }
    setOpenSignPDF(false);
    setSelectedFileUri(null);
  };
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const menuItems = [
    // {
    //   label: "Send Invoice for Signing",
    //   icon: <EditNoteIcon fontSize="small" />,

    //   onClick: () => {
    //     setCollectSignatureSwalOpen(true);
    //   },
    // },
    {
      label: "Download PDF",
      icon: (
        <Box
          sx={invoiceDetailMenuIconTile(
            IDET_TILE_PDF_BG,
            IDET_TILE_PDF_BORDER
          )}
        >
          <PictureAsPdfIcon
            sx={{ fontSize: "1.125rem", color: IDET_ICON_COLOR }}
          />
        </Box>
      ),
      onClick: async () => {
        setCollectSignatureLoader(true);
        setProgress(0);
        simulateProgress();
        try {
          await downloadPdf();
        } catch (error) {
          console.error("Error:", error);
          showToast.error("Failed to download the PDF. Please try again.");
        } finally {
          setCollectSignatureLoader(false);
          setProgress(0);
        }
      },
    },

    {
      label: "Print",
      icon: (
        <Box
          sx={invoiceDetailMenuIconTile(
            IDET_TILE_PRINT_BG,
            IDET_TILE_PRINT_BORDER
          )}
        >
          <PrintIcon sx={{ fontSize: "1.125rem", color: IDET_ICON_COLOR }} />
        </Box>
      ),
      onClick: async () => {
        setCollectSignatureLoader(true);
        setProgress(0);
        simulateProgress();
        try {
          await generatePDF();
        } catch (error) {
          console.error("Error:", error);
          showToast.error("Failed to print the PDF. Please try again.");
        } finally {
          setCollectSignatureLoader(false);
          setProgress(0);
        }
      },
    },
  ];

  const handleCollectSignature = async () => {
    setCollectSignatureSwalOpen(false);
    setCollectSignatureLoader(true);
    setProgress(0);
    simulateProgress();

    try {
      // Send InvoiceId directly - backend will generate PDF buffer on-the-fly without storing in CDN
      const data = {
        title: "Agreement",
        subject: "Please sign the agreement",
        message: "Please review and sign the document",
        signers: [
          {
            email: invoicedata?.customer?.EmailAddress,
            name: invoicedata?.customer?.FirstName,
            order: 0,
          },
        ],
        CompanyId: invoicedata?.CompanyId,
        InvoiceId: invoicedata?.InvoiceId,
        // No fileName needed - backend generates PDF buffer directly from InvoiceId
      };
      // First check if document is already signed
      const existingFiles = invoicedata?.dropboxFiles || [];
      const isAlreadySigned = existingFiles.some(file => 
        file?.statusCode?.data?.signatureRequest?.signatures?.[0]?.statusCode === "signed"
      );

      if (isAlreadySigned) {
        showToast.warning("This document has already been signed.");
        return;
      }
      const response = await AxiosInstance.post(
        "/v1/signature/signature_request/send",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.statusCode === 200) {
        const signatureType = response?.data?.signatureType || "Dropbox";
        const serviceName = signatureType === "Documenso" ? "Documenso" : "Dropbox";
        showToast.success(`PDF successfully sent to ${serviceName}!`);
      }
      if (response?.data?.statusCode === 403) {
        showToast.warning(
          "A signature request is already pending. Please complete it first."
        );
      }
      if (response?.data?.statusCode === 405) {
        showToast.warning("A signature request is already pending. Please complete it first.");
      } else if (response?.status === 200) {
        const signatureType = response?.data?.signatureType || "Dropbox";
        const serviceName = signatureType === "Documenso" ? "Documenso" : "Dropbox";
        showToast.success(`PDF successfully sent to ${serviceName}!`);
      }
      fetchData();
    } catch (error) {
      console.error("Error:", error);

      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Failed to send the PDF. Please try again.";

      showToast.warning(errorMessage);
    } finally {
      setCollectSignatureLoader(false);
      setProgress(0);
    }
  };

  const handleDropboxDelete = async (id) => {
    sendSwal(isDonationMode).then(async (deleteReason) => {
      if (deleteReason) {
        try {

          const response = await AxiosInstance.delete(
            `/v1/signature/delete/${id}`,
            {
              data: { DeleteReason: deleteReason },
            }
          );
          if (response?.data?.statusCode === 200) {
            showToast.success(response?.data?.message);
            setInvoicedata((prevData) => ({
              ...prevData,
              dropboxFiles: prevData?.dropboxFiles?.filter(
                (file) => file?.RequestId !== id
              ),
            }));
          } else {
            showToast.warning(response?.data?.message);
          }
        } catch (error) {
          if (error?.response) {
            showToast.error(
              error?.response?.data?.message || "An error occurred"
            );
          } else {
            showToast.error(error?.message || "An error occurred");
          }
        }
      }
    });
  };
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";

  return (
    <>
      <InvoiceDetail
        loader={loader}
        CompanyUrl={CompanyUrl}
        location={location}
        invoicedata={invoicedata}
        data={data}
        setMail={setMail}
        setFile={setFile}
        handleEditClick={handleEditClick}
        dropdownOpen={dropdownOpen}
        toggle={toggle}
        downloadPdf={downloadPdf}
        generatePDF={generatePDF}
        handleCopy={handleCopy}
        open={open}
        setOpen={setOpen}
        file={file}
        mail={mail}
        options={options}
        navigate={navigate}
        sendMail={sendMail}
        handleCancelInvoice={handleCancelInvoice}
        setInvoiceStatus={setInvoiceStatus}
        invoiceStatus={invoiceStatus}
        baseUrl={baseUrl}
        toggleDropdown={toggleDropdown}
        menuItems={menuItems}
        collectSignatureLoader={collectSignatureLoader}
        progress={progress}
        handleOpenSignPDFDialog={handleOpenSignPDFDialog}
        openSignPDF={openSignPDF}
        handleCloseDialog={handleCloseDialog}
        selectedFileUri={selectedFileUri}
        handleDropboxDelete={handleDropboxDelete}
        dateFormat={dateFormat}
        tokenDecode={tokenDecode}
        isDonationMode={isDonationMode}
      />
      
      <CustomSwal
        isOpen={collectSignatureSwalOpen}
        onClose={() => setCollectSignatureSwalOpen(false)}
        onConfirm={handleCollectSignature}
        title="Are you sure?"
        text="Are you sure you want to collect the customer's signature?"
        confirmButtonText="Process"
        cancelButtonText="Cancel"
        requireInput={false}
        isDonationMode={isDonationMode}
      />
      
      <CustomSwal
        isOpen={cancelInvoiceSwalOpen}
        onClose={handleCancelInvoiceClose}
        onConfirm={handleCancelInvoiceConfirm}
        title="Are you sure?"
        text="Once cancelled, you will not be able to Activate this Invoice!"
        confirmButtonText="Confirm"
        cancelButtonText="Cancel"
        placeholder="Enter reason for cancelling"
        requireInput={true}
        isDonationMode={isDonationMode}
      />
      <EmailDisabledModal
        open={emailDisabledModalOpen}
        onClose={() => setEmailDisabledModalOpen(false)}
        message={emailDisabledMessage}
      />
    </>
  );
}

export default InvoiceDetails;
